import { useQuery } from '@tanstack/react-query';
import { getPatientMedicalDocumentDownloadLink } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useMedicalDocumentLinkQuery = (patientId: string, medicalDocumentId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'user', patientId, 'document', medicalDocumentId, 'link' ],
    queryFn: async() => {
      const downloadLinkResponse = await getPatientMedicalDocumentDownloadLink(patientId, medicalDocumentId);

      return downloadLinkResponse.data.downloadLink;
    },
    staleTime: 60 * 60 * 1000, // 60 minutes
    ...opts,
  });
};
